'use client'

import { ErrorScreen } from '@/components/ErrorScreen'
import { useEffect } from 'react'
import './globals.css'

/*
 * Last-resort boundary for exceptions thrown in the root layout itself (where
 * app/error.tsx can't reach). It replaces the root layout entirely, so it must
 * render its own <html>/<body> — and it renders outside every provider, which
 * is why ErrorScreen is deliberately context-free.
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error(error)
  }, [error])

  return (
    <html lang='en'>
      <body className='antialiased font-sans'>
        <ErrorScreen reset={reset} />
      </body>
    </html>
  )
}
